export default "__VITE_PUBLIC_ASSET__02b82ae4__"